import type { LogtoConfig } from "@logto/vue";

export const logtoConfig: LogtoConfig = {
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_LOGTO_APP_ID,
  // `offline_access` issues a refresh token so the SDK can silently
  // renew the id_token when it expires, instead of every API call
  // failing with `"exp" claim timestamp check failed` 401s after the
  // user has been idle for a while.
  scopes: ["openid", "profile", "email", "offline_access"],
};

export const callbackUrl = `${window.location.origin}/callback`;
export const postSignOutUrl = `${window.location.origin}/`;
